import { TokenListItem } from '@/components';
import APP_CONFIG from '@/config/app';
import { TokenInterface } from '@/interfaces';
import { formatNumberToAmountInUsdString } from '@/utils/formatUtils';
import { FC, useCallback, useRef } from 'react';
import AutoSizer from 'react-virtualized-auto-sizer';
import { FixedSizeList as List, ListChildComponentProps } from 'react-window';
const visualizeElementsAndSpacing = false;
const borderClassToVisualizeElementsAndSpacing = visualizeElementsAndSpacing
  ? 'border-white border'
  : '';
const { MAIN_PADDING, MAIN_GAP } = APP_CONFIG.STYLES;
interface TokenListProps {
  tokens: TokenInterface[];
  showNetwork?: boolean;
  showNetworkPrefix?: boolean;
  showTicker?: boolean;
  onItemClick?: (token: TokenInterface) => void;
  applyRoundedMask?: boolean;
  itemHeight?: number;
}
const TokenList: FC<TokenListProps> = ({
  tokens,
  showNetwork = true,
  showNetworkPrefix = true,
  showTicker = false,
  onItemClick,
  applyRoundedMask,
  itemHeight = 75,
}) => {
  const listRef = useRef<List>(null);
  const Row = useCallback(
    ({ index, style }: ListChildComponentProps) => {
      const token = tokens[index];
      if (!token) return null;
      const subTexts: string[] = [token.name];
      if (showNetwork) {
        const networkDisplayName =
          token.blockchainDisplayName || token.blockchain || '';
        const networkString = showNetworkPrefix
          ? `Network ${networkDisplayName}`
          : networkDisplayName;
        subTexts.push(networkString);
      }
      subTexts.push(
        `Market Cap. ${formatNumberToAmountInUsdString(
          token.marketCapInUsd || 0,
        )}`,
      );
      subTexts.push(
        `Price ${formatNumberToAmountInUsdString(token.priceInUsd || 0)}`,
      );
      return (
        <div
          style={style}
          onClick={() => onItemClick?.(token)}
          className={`cursor-pointer ${borderClassToVisualizeElementsAndSpacing}`}
        >
          <TokenListItem
            token={token}
            showTicker={showTicker}
            showNetwork={showNetwork}
            showNetworkPrefix={showNetworkPrefix}
            applyRoundedMask={applyRoundedMask}
            subText={subTexts[0]}
            subSubText={subTexts[1]}
            subSubSubText={subTexts[2]}
            subSubSubSubText={subTexts[3]}
          />
        </div>
      );
    },
    [
      tokens,
      showTicker,
      showNetwork,
      showNetworkPrefix,
      onItemClick,
      applyRoundedMask,
    ],
  );
  return (
    <div className="h-full w-full">
      <AutoSizer>
        {({ height, width }) => (
          <List
            ref={listRef}
            height={height}
            width={width}
            itemCount={tokens.length}
            itemSize={itemHeight}
            overscanCount={10}
            useIsScrolling={true}
            className={`flex flex-col p${MAIN_PADDING} gap${MAIN_GAP} ${borderClassToVisualizeElementsAndSpacing}`}
          >
            {Row}
          </List>
        )}
      </AutoSizer>
    </div>
  );
};
export default TokenList;
